import { getBaseProductInMaker, getProductColorInMaker } from '@modules/Maker/F/getSth.js';
import { VectorEditorConstantS } from '@modules/VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { BpOptionUploadTypeS } from '@modules/BpOption/UploadType/S/Function/module/BpOptionUploadTypeS.js';
import { NewMakerUtilS } from '@modules/NewMaker/Util/S/Function/module/NewMakerUtilS.js';
import { NewMakerEndServiceF } from '@modules/NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';
import { BpDiscountSetS } from '@modules/BpDiscountSet/S/Function/module/BpDiscountSetS.js';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';

function hasDesignForCanvasEditor(product) {
  if (BpOptionUploadTypeS.UPLOAD_TYPE.isDirectType(product))
    return !!BpOptionUploadTypeS.UPLOAD_TYPE.option.direct.getPrintingFile(product);
  return NewMakerUtilS.hasDesignsInFaces(product);
}

function hasDesignForSvgProductData(product) {
  return !!product.svg_product_id || !!product._.svg_product_materials?.length;
}

export const makerStatus = {
  hasBpDiscountSet: () => {
    const product_color = getProductColorInMaker();
    return !!product_color._.base_product._?.bp_discount_set?.is_public;
  },
  isVectorEditor: () => {
    const base_product = getBaseProductInMaker();
    return VectorEditorConstantS.EDITOR_TYPES.includes(base_product.maker_type);
  },
  isKeyringEditor: () => {
    const base_product = getBaseProductInMaker();
    return VectorEditorConstantS.KEYRING_EDITOR === base_product.maker_type;
  },
  isCanvasEditor: () => {
    const base_product = getBaseProductInMaker();
    return ['DEFAULT', 'MASKING_TAPE'].includes(base_product.maker_type);
  },
  isFlexiMaker: () => {
    const base_product = getBaseProductInMaker();
    return base_product.maker_type === 'FLEXI';
  },
  useMcon: () => {
    const base_product = getBaseProductInMaker();
    return G.collabo_type === '' && base_product.use_mcon;
  },
  useEmbro: () => {
    const base_product = getBaseProductInMaker();
    return base_product.can_embro;
  },
  hasDesignForCanvasEditor,
  hasDesignForSvgProductData,
  isDesignedProduct: (product) => {
    if (makerStatus.isVectorEditor()) {
      return hasDesignForSvgProductData(product);
    } else if (makerStatus.isCanvasEditor()) {
      return hasDesignForCanvasEditor(product);
    } else {
      return true;
    }
  },
  isPlainOrderCheckNotPassed: () => {
    try {
      const product = getProductColorInMaker();
      if (!product._.base_product.is_plain_order_disallowed) return;
      if (!NewMakerEndServiceF.makerStatus.isDesignedProduct(product)) return true;
    } catch (e) {
      ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'isPlainOrderCheckNotPassed' } });
    }
  },
  isMoqOrderCheckNotPassed: () => {
    try {
      const product = getProductColorInMaker();
      if (!BpDiscountSetS.isMoqProduct(product._.base_product._.bp_discount_set)) return;
      if (!NewMakerEndServiceF.makerStatus.isDesignedProduct(product)) return true;
    } catch (e) {
      ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'isMoqOrderCheckNotPassed' } });
    }
  },
};
